document.addEventListener("DOMContentLoaded", () => {
  const SHEET_ID = "1XMUqPTqCWv6hRnMnEo48TmdSDVsy7hIjpG8K4YuArVE";
  const API_KEY = "AIzaSyBDScjStzt3l1m7T-ctggX_3S5unFImWSE";
  const RANGE = "Sheet1";
  const SHEET_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${RANGE}?key=${API_KEY}`;

  const stateDropdown = document.getElementById("stateDropdown");
  const cityDropdown = document.getElementById("cityDropdown");
  const searchBtn = document.getElementById("searchBtn");

  const storeCount = document.getElementById("storeCount");
  const storeCardsContainer = document.getElementById("storeCards");
  const template = document.getElementById("storeCardTemplate");

  const loadMoreWrapper = document.getElementById("loadMoreWrapper");
  const loadMoreBtn = document.getElementById("loadMoreBtn");
  const endMessage = document.getElementById("endMessage");

  const noStoreOverlay = document.getElementById("noStoreOverlay");

  let stores = [];
  let filteredResults = [];
  let currentIndex = 0;
  const BATCH_SIZE = 6;

  function normalize(str) {
    return str ? str.trim().toLowerCase() : "";
  }

  async function fetchStoreData() {
    try {
      const res = await fetch(SHEET_URL);
      const data = await res.json();
      const rows = data.values;
      const headers = rows[0];
      const records = rows.slice(1).map((row) => {
        return headers.reduce((obj, key, i) => {
          obj[key.trim()] = row[i] ? row[i].trim() : "";
          return obj;
        }, {});
      });

      stores = records;
      populateStateDropdown(stores);

      // ✅ Load all stores on first visit
      filteredResults = stores;
      renderInitial();
    } catch (err) {
      console.error("Error fetching store data:", err);
    }
  }

  function populateStateDropdown(data) {
    const uniqueStates = [...new Set(data.map((item) => item["STORE STATE"]).filter(Boolean))];
    uniqueStates.sort().forEach((state) => {
      const option = document.createElement("option");
      option.value = state;
      option.textContent = state;
      stateDropdown.appendChild(option);
    });
  }

  function populateCityDropdown(selectedState) {
    cityDropdown.innerHTML = '<option value="">Select a City</option>';
    const filtered = stores.filter((s) => normalize(s["STORE STATE"]) === normalize(selectedState));
    const cities = [...new Set(filtered.map((s) => s["STORE CITY"]).filter(Boolean))];
    cities.sort().forEach((city) => {
      const option = document.createElement("option");
      option.value = city;
      option.textContent = city;
      cityDropdown.appendChild(option);
    });
    cityDropdown.disabled = false;
  }

  function renderInitial() {
    currentIndex = 0;
    storeCardsContainer.innerHTML = "";
    hideNoResults();

    if (filteredResults.length === 0) {
      showNoResults();
      return;
    }

    loadMoreWrapper.style.display = filteredResults.length > BATCH_SIZE ? "block" : "none";
    loadMoreBtn.style.display = filteredResults.length > BATCH_SIZE ? "inline-block" : "none";
    endMessage.style.display = "none";

    renderNextBatch();
  }

  function renderNextBatch() {
    const end = currentIndex + BATCH_SIZE;
    const slice = filteredResults.slice(currentIndex, end);

    slice.forEach((store) => {
      const clone = template.content.cloneNode(true);
      const card = clone.querySelector(".store-card");

      const fields = [
        { icon: "🏠", label: "Address", key: "ADDRESS" },
        { icon: "☎️", label: "Landline", key: "LANDLINE NUMBER" },
        { icon: "📞", label: "Phone", key: "PHONE NUMBER", link: "tel:" },
        { icon: "⏰", label: "Open Timing", key: "STORE OPEN TIMING" },
        { icon: "⏳", label: "Close Timing", key: "STORE CLOSE TIMING" }
      ];

      let html = "";

      fields.forEach((field) => {
        const value = store[field.key]?.trim();
        if (value && value.toLowerCase() !== "n/a" && value !== "-") {
          if (field.link) {
            html += `<p><span class="field-icon">${field.icon}</span><strong>${field.label}:</strong> <a href="${field.link}${value}" target="_blank">${value}</a></p>`;
          } else {
            html += `<p><span class="field-icon">${field.icon}</span><strong>${field.label}:</strong> ${value}</p>`;
          }
        }
      });

      const lat = store["Latitude"];
      const lng = store["Longitude"];
      const mapLink =
        lat && lng && !isNaN(lat) && !isNaN(lng)
          ? `<p><span class="field-icon">🗺️</span><strong>Location:</strong> <a href="https://www.google.com/maps?q=${lat},${lng}" target="_blank">View on Map</a></p>`
          : "";

      card.innerHTML = `<h3 class="store-name">${store["CREATE STORE NAME"] || "Unnamed Store"}</h3>${html}${mapLink}`;
      setTimeout(() => card.classList.add("loaded"), 50);
      storeCardsContainer.appendChild(clone);
    });

    currentIndex = end;

    if (currentIndex >= filteredResults.length) {
      loadMoreBtn.style.display = "none";
      endMessage.style.display = "block";
    }
  }

  function showNoResults() {
    storeCardsContainer.innerHTML = "";
    noStoreOverlay.style.display = "block";
    loadMoreWrapper.style.display = "none";
    endMessage.style.display = "none";
  }

  function hideNoResults() {
    noStoreOverlay.style.display = "none";
  }

  function handleSearch() {
    const selectedState = stateDropdown.value;
    const selectedCity = cityDropdown.value;

    const isBlank = !selectedState && !selectedCity;

    if (isBlank) {
      filteredResults = [];
    } else {
      filteredResults = stores;

      if (selectedState) {
        filteredResults = filteredResults.filter((s) => normalize(s["STORE STATE"]) === normalize(selectedState));
      }

      if (selectedCity) {
        filteredResults = filteredResults.filter((s) => normalize(s["STORE CITY"]) === normalize(selectedCity));
      }
    }

    renderInitial();
  }

  // Event listeners
  searchBtn.addEventListener("click", handleSearch);
  loadMoreBtn.addEventListener("click", renderNextBatch);

  stateDropdown.addEventListener("change", (e) => {
    const selectedState = e.target.value;
    if (selectedState) {
      populateCityDropdown(selectedState);
    } else {
      cityDropdown.disabled = true;
      cityDropdown.innerHTML = '<option value="">Select a City</option>';
    }
  });

  fetchStoreData();
});
